import type { CorpusLanguage, CorpusResult } from '../serviceExecutionApi';

const languages: Record<CorpusLanguage, string> = {
  ru: 'Русский', kk: 'Қазақша', en: 'English', tr: 'Türkçe',
  mixed: 'Смешанный', other: 'Другой язык', und: 'Не определён', zxx: 'Без языкового содержания',
};

function candidateName(code: string) {
  if (code in languages) return languages[code as CorpusLanguage];
  try {
    return new Intl.DisplayNames(['ru'], { type: 'language', fallback: 'none' }).of(code) || languages.other;
  } catch {
    return languages.other;
  }
}

export function CorpusLanguageReview({ unit, number, onChange, disabled }: {
  unit: CorpusResult['units'][number];
  number: number;
  onChange: (changes: Partial<CorpusResult['units'][number]>) => void;
  disabled: boolean;
}) {
  return <fieldset disabled={disabled}>
    <legend>Язык фрагмента {number}</legend>
    {unit.language_detection && <p>Предложение модели: {candidateName(unit.language_detection.candidate)}.
      {unit.language_detection.reason ? ` ${unit.language_detection.reason}` : ' Проверьте по тексту, особенно при смешении языков.'}
    </p>}
    <label>Принятый язык фрагмента {number}
      <select value={unit.language || 'und'} onChange={(event) => onChange({ language: event.target.value as CorpusLanguage, language_verified: false })}>
        {Object.entries(languages).map(([code, name]) => <option key={code} value={code}>{name}</option>)}
      </select>
    </label>
    <label><input type="checkbox" disabled={disabled || !unit.language || unit.language === 'und'} checked={!!unit.language_verified}
      onChange={(event) => onChange({ language_verified: event.target.checked })} /> Проверил язык фрагмента {number}</label>
    <small>Если исправили язык, укажите основание в решении исполнителя и повторно подтвердите выбор.</small>
  </fieldset>;
}
